/**
 * جلوگیری از نمایش آبجکت خام API (مثل { message, permissions }) در نوتیف antd
 */
import { message } from 'antd';
import { extractApiUserMessage, isPermissionDeniedPayload } from './api';

const coerceMessageContent = (content, defaultMessage = 'خطا در انجام عملیات') => {
  if (content == null) return defaultMessage;
  if (typeof content === 'string') return extractApiUserMessage(content, defaultMessage);
  if (typeof content === 'number' || typeof content === 'boolean') return String(content);

  if (typeof content === 'object') {
    if (isPermissionDeniedPayload(content)) {
      return extractApiUserMessage(content, defaultMessage);
    }
    if (typeof content.message === 'string' && !('permissions' in content)) {
      return extractApiUserMessage(content, defaultMessage);
    }
    if (typeof content.message === 'string') {
      return extractApiUserMessage(content, defaultMessage);
    }
    return defaultMessage;
  }

  return defaultMessage;
};

const wrapMessageArgs = (args, defaultMessage) => {
  if (!args.length) return args;

  const [first, ...rest] = args;

  if (first && typeof first === 'object' && 'content' in first) {
    return [
      {
        ...first,
        content: coerceMessageContent(first.content, defaultMessage),
      },
      ...rest,
    ];
  }

  return [coerceMessageContent(first, defaultMessage), ...rest];
};

const MESSAGE_TYPES = ['open', 'success', 'info', 'warning', 'error', 'loading'];

/** یک‌بار در App فراخوانی شود — همهٔ message.error/warning از متن فارسی استفاده می‌کنند */
export const installSafeMessageHandlers = () => {
  MESSAGE_TYPES.forEach((type) => {
    const original = message[type];
    if (typeof original !== 'function') return;

    message[type] = (...args) => original(...wrapMessageArgs(args));
  });
};
